
import { AppFilter, AppTable, AppTableColumn, ModalButton } from '../../_models/models';
import { Builder } from '../../_models';
export const today: Date = new Date();
export const initialDate: Date = new Date(today.getFullYear() - 1, 0, 1);
export const GOOGLE_ACCOUNTID = 311912;
export const billingHistoryFiltersConfig: AppFilter[] = [
  Builder.create(AppFilter, 'billingHistoryDatesRange', 'DATES_RANGE', 'timestamp', 'Date Range (EST)', '')
    .selectedValues([initialDate, today])
    .isRequired(true)
    .defaultValues([initialDate, today])
    .build(),
];

export const billingHistoryConfig: AppTable = new AppTable('billingInfoTable', 0, 12, 'billPaymentDate', 'desc', true, true);


export const billingHistoryTableButtons = [
  {id: 'generateBillingReportButton', type: 'SECONDARY-BUTTON', title: 'Retrieve History', hasLoadingSpinner: false},
];

export const billingHistoryTableColumns: AppTableColumn[] = [
  {id: 'billingInfoDate', prop: 'billPaymentDate', displayName: 'Payment Date', type: 'date-full-month-day-year', isSortEnabled: true},
  {id: 'billingInfoPayment', prop: 'totalAmount', displayName: 'Payment Amount', type: 'currency',  isSortEnabled: true},
  {
    id: 'actions', prop: 'actions', displayName: 'Details', type: 'actions', isSortEnabled: false,
    actions: [
      {id: 'billPaymentDetails', name: 'moreDetails', auth: 'canRead', displayName: 'Payment Details'},
    ]
  },
];

export const modalButtons: ModalButton[] = [
  {type: 'APPROVE', text: 'Ok'}
];

export const authPermissions = {
  canRead: true,
  canCreate: false,
  canUpdate: false,
  canDelete: false,
};
